/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_No_PostsInputs */

const en_blog_no_posts = /** @type {(inputs: Blog_No_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts yet — check back soon.`)
};

const zh_blog_no_posts = /** @type {(inputs: Blog_No_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无文章,敬请期待。`)
};

/**
* | output |
* | --- |
* | "No posts yet — check back soon." |
*
* @param {Blog_No_PostsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_no_posts = /** @type {((inputs?: Blog_No_PostsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_No_PostsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_no_posts(inputs)
	return zh_blog_no_posts(inputs)
});
export { blog_no_posts as "blog.no_posts" }